/**
 * Port of `repos/opencode/packages/ui/src/components/sticky-accordion-header.tsx`.
 *
 * An accordion header that sticks while its section scrolls. Note it carries *both*
 * `data-slot="accordion-header"` (from Accordion.Header) and
 * `data-component="sticky-accordion-header"` — the vendored CSS selects on each.
 */

import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { Accordion } from "./accordion.tsx";

export interface StickyAccordionHeaderProps
  extends ComponentPropsWithoutRef<typeof Accordion.Header> {
  children?: ReactNode;
}

export function StickyAccordionHeader({ children, ...props }: StickyAccordionHeaderProps) {
  return (
    <Accordion.Header data-component="sticky-accordion-header" {...props}>
      {children}
    </Accordion.Header>
  );
}
